import { ReasonForNegativeScore } from "./QaScore.model";

export const questionToReasons: Record<string, ReasonForNegativeScore[]> = {
  "UNDERSTAND THE INQUIRY": [
    "poor_active_listening",
    "repetitive_questions",
    "inconsistent_information",
    "language_barriers",
    "missed_to_ask_clarifying_question",
    "rushed_responses",
  ],
  "SHOW EMPATHY": [
    "lack_of_empathy",
    "failure_to_acknowledge_mistake",
    "long_wait_times",
    "lack_of_confidence",
    "inability_to_address_urgency",
    "impersonal_interactions",
    "unresponsive",
  ],
  "EXPLAIN PLAN OF ACTION": [
    "not_getting_to_the_point",
    "lack_of_customer_education",
    "inadequate_follow_up",
    "inaccurate_promises",
    "missed_to_set_proper_expectations",
    "invalid_escalations",
  ],
  "RESOLUTION CONFIRMATION": [
    "no_thorough_investigation",
    "lack_of_product_knowledge_expertise",
    "unresolved_issues",
    "faild_to_confirm_resolution",
  ],
};
